import type {EvidenceJobDetail} from '../../shared/operations';
import type {CostRecord} from '../../shared/contracts';
import {useItems} from '../api';
import {useWorkspace} from '../App';
import {ErrorBox,Fact,Loading,money} from '../ui';
import {reviewCosts} from '../review-costs';
import {aiNoteMentionsCurrencyAmount} from '../review-cost-warning';

export function ReviewOutcome({job:j}:{job:EvidenceJobDetail}){
 const w=useWorkspace(),costs=useItems<CostRecord>(j.appliedChanges?.costIds.length?'costs?vehicleId='+encodeURIComponent(j.vehicleId):'',w.revision);
 const changes=j.appliedChanges;
 const result=changes&&costs.data?reviewCosts(j.vehicleId,changes.costIds,costs.data):null;
 const note=j.analysis?.summary||j.resultSummary;
 return <>
  {changes?<dl className="analysis-counts">
   <Fact label="Vehicle details saved">{changes.fieldIds.length}</Fact>
   <Fact label="Equipment details saved">{changes.equipmentIds.length}</Fact>
   <Fact label="Vehicle notes saved">{changes.observationIds.length}</Fact>
   <Fact label="Cost entries saved">{changes.costIds.length}</Fact>
   <Fact label="Questions to answer">{j.questions.length}</Fact>
  </dl>:<p>Saved update counts are not available for this analysis.</p>}
  {!!changes?.costIds.length&&<section aria-label="Current linked costs">
   <h3>Current linked costs</h3>
   {costs.error?<ErrorBox message={costs.error} retry={costs.reload}/>:!result||costs.loading?<Loading/>:<>
    <dl className="facts-grid">{result.totals.map(t=><Fact key={[t.currency,t.basis,t.direction].join('/')} label={`${t.basis==='estimate'?'Estimated ':''}${t.direction==='credit'?'credits':'expenses'} · ${t.currency}`}>{t.amountMinor===null?'Amount unavailable':money(t.amountMinor,t.currency)}</Fact>)}</dl>
    {result.voided>0&&<p className="muted">{result.voided} voided {result.voided===1?'entry is':'entries are'} excluded.</p>}
    {result.missing>0&&<p className="error-text">{result.missing} linked {result.missing===1?'entry could':'entries could'} not be loaded. The amounts shown are incomplete.</p>}
    <p className="muted">Amounts come from the current saved cost entries. <a href={'#vehicle/'+j.vehicleId+'/costs'}>Review vehicle costs</a></p>
   </>}
  </section>}
  {note&&aiNoteMentionsCurrencyAmount(note)&&<p className="analysis-amount-warning" role="note">AI totals can be wrong. Check the saved costs and original files before relying on these amounts.</p>}
  {note&&<details className="disclosure"><summary>AI notes</summary><div className="detail-body"><p className="preserve">{note}</p></div></details>}
 </>;
}
